import { NoteDto } from './note';

enum WorkspaceLabelKind {
  default = 'default',
  time = 'time',
}

interface WorkspaceLabelDTO {
  clock: number;
  color: string;
  createdAt: number;
  deleted: boolean;
  globalId: string;
  style: string;
  title: string;
  updatedAt: number;
  userId: number;
  workspaceId: string;
  kind: WorkspaceLabelKind;
}

export interface TaskListDTO {
  id?: number;
  globalId: string;
  userId: number;
  title: string;
  workspaceId: string;
  noteGlobalId: string | null;
  createdAt: number;
  updatedAt: number;
  order: string[];
  boardId?: string;
}

export interface TaskDTO {
  id?: number;
  globalId: string;
  userId: number;
  lastUpdateUserId: number;
  title: string;
  workspaceId: string;
  taskListId: string;
  done: boolean;
  showTime: boolean;
  description?: boolean;
  deadlineDate?: number | null;
  createdAt: number;
  updatedAt: number;
  attachmentsCount: number;
}

interface TaskAssigneeDTO {
  userId: string;
  setByUserId?: string;
  workspaceId?: string;
  taskId: string;
  createdAt?: number;
}

interface TaskReminderDTO {
  globalId: string;
  userId: number;
  lastUpdateUserId: number;
  workspaceId: string;
  taskId: string;
  triggered: boolean;
  beforeValue: number | null;
  beforeUnit: 'minute' | 'hour' | 'day';
  createdAt: number;
  updatedAt: number;
}

interface TaskLabelDTO {
  userId: number;
  workspaceId: string;
  labelId: string;
  taskId: string;
  createdAt: number;
}

interface UsageItem {
  count: number;
  limit: number;
  reached: boolean;
}

interface UsageDTO {
  deadlineDates: UsageItem;
  reminders: UsageItem;
}

export interface BoardDTO {
  id?: number;
  globalId: string;
  userId: number;
  title: string;
  workspaceId: string;
  noteGlobalId: string | null;
  orgId: string;
  noteId: string;
  columnsOrder: string[];
  manageableColumns: boolean;
  createdBy: number;
  createdAt: number;
  updatedAt: number;
}

export interface GetTaskListResponse {
  taskList: TaskListDTO;
  tasks: TaskDTO[];
  assignees: TaskAssigneeDTO[];
  reminders: TaskReminderDTO[];
  labels: TaskLabelDTO[];
  notes: NoteDto[];
  usage: UsageDTO[];
  workspaceLabels: WorkspaceLabelDTO[];
}

export interface GetShareTasksResponse {
  boards: BoardDTO[];
  taskLists: TaskListDTO[];
  tasks: TaskDTO[];
}

export interface UpdateTaskResponse {
  task?: TaskDTO;
  assignees: TaskAssigneeDTO[];
  reminders: TaskReminderDTO[];
  labels: TaskLabelDTO[];
  workspaceLabels: WorkspaceLabelDTO[];
}

export interface SearchTasksResponse {
  filters: {
    workspaceIds: string[];
    taskIds: string[];
    taskListIds: string[];
    assigneeUserIds: number[];
    labelKeys: string[];
    deadlines: string[];
    noteKeys: string[];
    types: string[];
  };
  offset: number;
  limit: number;
  total: number;
  pit: string;
  taskLists: TaskListDTO[];
  boards: BoardDTO[];
  tasks: TaskDTO[];
}
